module.exports = __webpack_public_path__ + "static/media/mb-logo.0db2db7c.webp";